import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateTenant, CreateTenantAdmin, Tenant, TenantAdmin } from '../models/tenant.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private http = inject(HttpClient);
  private url = `${apiBase}/tenants`;

  getAll(): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(this.url);
  }

  create(data: CreateTenant): Observable<Tenant> {
    return this.http.post<Tenant>(this.url, data);
  }

  setActive(id: number, isActive: boolean): Observable<Tenant> {
    return this.http.patch<Tenant>(`${this.url}/${id}`, { isActive });
  }

  getAdmins(tenantId: number): Observable<TenantAdmin[]> {
    return this.http.get<TenantAdmin[]>(`${this.url}/${tenantId}/admins`);
  }

  createAdmin(tenantId: number, data: CreateTenantAdmin): Observable<TenantAdmin> {
    return this.http.post<TenantAdmin>(`${this.url}/${tenantId}/admins`, data);
  }

  removeAdmin(tenantId: number, personnelId: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${tenantId}/admins/${personnelId}`);
  }
}
